import React from 'react';

import { SVGComponentProps } from './svg.types';

const ArrowLeftSVG = ({
  stroke = 'currentColor',
  size = '1em',
  strokeWidth = 1,
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M12.6667 8H3.33337"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
        />
        <path
          d="M8.00004 12.6666L3.33337 7.99992L8.00004 3.33325"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
        />
      </svg>
    </span>
  );
};

export default ArrowLeftSVG;
